import React from 'react';
import MondaHomePage from '../../containers/FirstPage/MondaHomePage';

const StaticPages = () => <MondaHomePage />;

export default StaticPages;
